export default __webpack_public_path__ + "static/media/credit-card.4bbef266.svg";